import { cx } from '@emotion/css';
import styled from '@emotion/styled';

import { Color, TextAlign, Typography, TypographyKey } from '@common/styles';
import { DataCustomTaKeyAttribute } from '@common/test-automation';

interface Props extends DataCustomTaKeyAttribute {
  color?: Color;
  align?: TextAlign;
  variation?: TypographyKey;
  className?: string;
  as?: keyof JSX.IntrinsicElements;
}

export const BaseText: React.FC<React.PropsWithChildren<Props>> = ({
  color,
  align,
  variation = 'BODY_17_REGULAR',
  className,
  children,
  as,
  'data-custom-ta-key': dataCustomTaKey,
}) => {
  return (
    <Wrapper
      as={as}
      className={cx(Typography[variation], className)}
      $color={color}
      align={align}
      data-custom-ta-key={dataCustomTaKey}
    >
      {children}
    </Wrapper>
  );
};

const Wrapper = styled.span<{ $color?: Color; align?: TextAlign }>`
  ${({ $color }) => $color && `color: ${$color};`}
  ${({ align }) => align && `text-align: ${align};`}
`;
